import { useQuery } from '@tanstack/react-query';
import { aivaApi } from 'src/services';
import { CallPriority } from 'src/models';
import { UseQueryOverrideOptions } from '../common';

export type GetCallPriorityListResponse = {
  priorities: CallPriority[];
};

export const useGetCallPriorityList = (
  {} = {},
  options: UseQueryOverrideOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['getCallPriorityList'],
    queryFn: () =>
      aivaApi
        .get<GetCallPriorityListResponse>('/call/priorities')
        .then((res) => res.data),
  });
};
